import {useUpdateUserNotificationPreferencesMutation} from "@/api/userApi";
import NotificationToggleOffIcon from "@/assets/colorable/notification_toggle_off.svg?react";
import NotificationToggleOnIcon from "@/assets/colorable/notification_toggle_on.svg?react";
import {type FC} from "react";

const UserNotificationToggle: FC<{companyId: number; isInitiallyEnabled: boolean; userId: number}> = ({
  companyId,
  isInitiallyEnabled,
  userId,
}) => {
  const {mutate: updatePreferences, isPending: isUpdatingPreferences} = useUpdateUserNotificationPreferencesMutation({
    companyId,
    isInitiallyEnabled,
    userId,
  });

  return (
    <button onClick={() => updatePreferences()} disabled={isUpdatingPreferences}>
      {isInitiallyEnabled ? (
        <NotificationToggleOnIcon className="text-primary-dark-solid h-6 w-12 shrink-0" />
      ) : (
        <NotificationToggleOffIcon className="text-neutral-grey-light-dark h-6 w-12 shrink-0" />
      )}
    </button>
  );
};

export default UserNotificationToggle;
